type TagFilters = Record<string, number[]>

type StoreViewFetcher = (storeViewId: number) => Promise<unknown>
type LocationProductsFetcher = (tagFilters: TagFilters, page?: number | null, searchQuery?: string) => Promise<unknown>
type ShopLoadingSetter = (key: string, bool: boolean) => Promise<unknown> | unknown
type ClearPaginatedProducts = () => unknown

export type StoreViewProductRefreshResult = {
  shouldClearSearch: boolean
  nextSearch: string
  didRefreshProducts: boolean
}

export const isShopPath = (pathname: string): boolean => pathname.startsWith('/shop')

export const switchStoreViewAndRefreshProducts = async ({
  selectedStoreViewId,
  pathname,
  search,
  fetchCurrentStoreView,
  fetchLocationProducts,
  setLoading,
  clearPaginatedProducts
}: {
  selectedStoreViewId: number
  pathname: string
  search: string
  fetchCurrentStoreView: StoreViewFetcher
  fetchLocationProducts: LocationProductsFetcher
  setLoading: ShopLoadingSetter
  clearPaginatedProducts: ClearPaginatedProducts
}): Promise<StoreViewProductRefreshResult> => {
  if (!isShopPath(pathname)) {
    await fetchCurrentStoreView(selectedStoreViewId)

    return {
      shouldClearSearch: false,
      nextSearch: search,
      didRefreshProducts: false
    }
  }

  await setLoading('shopProducts', true)
  clearPaginatedProducts()
  await fetchCurrentStoreView(selectedStoreViewId)

  if (search) {
    return {
      shouldClearSearch: true,
      nextSearch: '',
      didRefreshProducts: false
    }
  }

  try {
    await fetchLocationProducts({}, 1, '')
  } finally {
    await setLoading('shopProducts', false)
  }

  return {
    shouldClearSearch: false,
    nextSearch: '',
    didRefreshProducts: true
  }
}
